import { SprocketIcon } from 'foundations-assets/icons/components/SprocketIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import unescapedText from 'I18n/utils/unescapedText';
import { ACTION_TYPE_ICON_MAP, DEFAULT_ACTION_TYPE_ICON_COLOR, MAX_VISIBLE_ICONS } from './constants/icon-group';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function getActionTypeIcon(actionType) {
  var _ACTION_TYPE_ICON_MAP, _ACTION_TYPE_ICON_MAP2;
  return (_ACTION_TYPE_ICON_MAP = (_ACTION_TYPE_ICON_MAP2 = ACTION_TYPE_ICON_MAP[actionType]) === null || _ACTION_TYPE_ICON_MAP2 === void 0 ? void 0 : _ACTION_TYPE_ICON_MAP2.icon) !== null && _ACTION_TYPE_ICON_MAP !== void 0 ? _ACTION_TYPE_ICON_MAP : SprocketIcon;
}
function getActionTypeColor(actionType) {
  var _ACTION_TYPE_ICON_MAP3, _ACTION_TYPE_ICON_MAP4;
  return (_ACTION_TYPE_ICON_MAP3 = (_ACTION_TYPE_ICON_MAP4 = ACTION_TYPE_ICON_MAP[actionType]) === null || _ACTION_TYPE_ICON_MAP4 === void 0 ? void 0 : _ACTION_TYPE_ICON_MAP4.color) !== null && _ACTION_TYPE_ICON_MAP3 !== void 0 ? _ACTION_TYPE_ICON_MAP3 : DEFAULT_ACTION_TYPE_ICON_COLOR;
}
function getActionTypeLabel(actionType) {
  return unescapedText(`marketplace-ui-common.workflowTemplates.actionTypes.${actionType}`);
}
export function WorkflowTemplateIconGroup({
  workflowActionTypes,
  maxIcons = MAX_VISIBLE_ICONS
}) {
  if (!workflowActionTypes.length) {
    return null;
  }
  const visibleTypes = workflowActionTypes.slice(0, maxIcons);
  const remainingCount = workflowActionTypes.length - visibleTypes.length;
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    gap: "200",
    "aria-label": unescapedText('marketplace-ui-common.workflowTemplates.iconGroupLabel'),
    role: "group",
    children: [/*#__PURE__*/_jsx(Flex, {
      gap: "100",
      children: visibleTypes.map((actionType, index) => /*#__PURE__*/_jsx(IconHolder, {
        "aria-label": getActionTypeLabel(actionType),
        backgroundColor: "fill-surface-default",
        borderWidth: "100",
        borderColor: "fill-accent-blue-default",
        borderStyle: "solid",
        borderRadius: "200",
        blockSize: "600",
        color: getActionTypeColor(actionType),
        icon: getActionTypeIcon(actionType),
        inlineSize: "600",
        padding: "0",
        size: "300"
      }, `${actionType}-${index}`))
    }), remainingCount > 0 && /*#__PURE__*/_jsxs(Text, {
      typography: "body-100",
      color: "text-core-subtle",
      "aria-label": unescapedText('marketplace-ui-common.workflowTemplates.moreActionTypes', {
        count: remainingCount
      }),
      children: ["+", remainingCount]
    })]
  });
}